import script from "./TikTok.vue?vue&type=script&setup=true&lang=js"
export * from "./TikTok.vue?vue&type=script&setup=true&lang=js"

import "./TikTok.vue?vue&type=style&index=0&id=1fce256a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fce256a"]])

export default __exports__